import React from "react";
import { Clock, MapPin, ShieldCheck, Check } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";

const cards = [
  { icon: Clock, title: "Horaires", lines: ["7 jours sur 7", "7h00 – 23h30 (heure de La Réunion)"] },
  { icon: MapPin, title: "Zone d'intervention", lines: ["Toute l'île de La Réunion (974)", "Consultation sur place ou à distance"] },
  { icon: ShieldCheck, title: "Confidentialité", lines: ["Discrétion absolue", "Aucune information partagée"] },
];

const points = ["Réponse rapide à votre demande", "Étude personnalisée de votre situation", "Travail sérieux et résultats durables", "Accompagnement jusqu'au bout"];

const Contact = () => (
  <section id="contact" className="py-24 md:py-32 lux-section-glow border-t border-amber-500/10" data-testid="contact-info-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle eyebrow="Contact" title="Consultez" gold="Maître Diamma"
        subtitle="Une consultation peut changer votre vie. N'attendez plus pour retrouver la paix et l'amour." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 100}>
            <div className="lux-card h-full p-8 text-center" data-testid={`contact-card-${i}`}>
              <c.icon className="w-8 h-8 text-amber-400 mx-auto mb-4" strokeWidth={1.5} />
              <h3 className="font-heading text-lg text-amber-100 mb-3">{c.title}</h3>
              {c.lines.map((l) => <p key={l} className="text-zinc-400 text-sm">{l}</p>)}
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className="rounded-2xl border border-amber-500/20 bg-zinc-950/70 p-8 md:p-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {points.map((p) => (
            <div key={p} className="flex items-center text-zinc-200">
              <Check className="w-5 h-5 text-amber-400 mr-3 flex-shrink-0" />{p}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Contact;
